import { Toast } from 'mint-ui'
export default {
    data() {
        return {
            gameInfo: {},
            gameList: []
        }
    },
    methods: {
        getCurrentYear() {
            return process.env.COPY_RIGHT_YEAR
        },
        setData() {
            const _this = this;
            const gameInfo = this.gameInfo;
            if (gameInfo && gameInfo.name) {
                _this.$store.state.gameName = _this.gameInfo.name;
                _this.$store.state.icon = _this.gameInfo.icon;
                _this.$store.state.serviceMail = _this.gameInfo.serviceMail || 'mgs-cs@mattel.com';
            } else {
                _this.$store.state.gameName = '';
                _this.$store.state.icon = '';
                _this.$store.state.serviceMail = 'mgs-cs@mattel.com';
                Toast({
                    message: 'gameID not matched！',
                });
            }
        },
        getGameList() {
            const _this = this;
            const gameID = this.$store.state.gameID?this.$store.state.gameID*1 :this.$store.state.gameID;
            _this.gameList = [];
            this.$axios({
                method: "post",
                url: "/privacy/game/info",
                data: {
                    gameID,
                    ua:navigator.userAgent || ''
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    _this.gameInfo = res.data && res.data.r ? res.data.r : {};
                    _this.setData();
                } else {
                    Toast({
                        message: res.data.d,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
                Toast({
                    message: this.$t("toast.error"),
                });
            });
        },
    }
}